/**
 *
 * @param {?string=} fileName
 */
export const getFileNameWithoutExtension = (fileName) => {
  const lastDotPos = (fileName ?? '').lastIndexOf('.');
  return lastDotPos >= 0 ? fileName?.substring(0, lastDotPos) ?? '' : fileName ?? '';
}

/**
 * @param {...(string|number|boolean|null)} fileNameChunks
 */
export const pathCombine = (...fileNameChunks) => (fileNameChunks ?? []).join('/');
